__webpack_require__.p = "/example/native-fn/";